import React from "react";
import styled from "styled-components";
import Theme from "../Theme/Theme";
import StudentRightSide from "../Components/StudentRightSide/StudentRightSide";
import StudentLeftSide from "../Components/StudentLeftSide/StudentLeftSide";
import { useState } from "react";

export default function MainEmployeeScreen() {
  const [navItems] = useState([
    {
      id: 1,
      img: "/Assets/Images/NavigatorIcons/CheckRequestAdminIcon/Grey.svg",
      activeImg: "/Assets/Images/NavigatorIcons/CheckRequestAdminIcon/Blue.svg",
      navigate: "/admin-dashboard/check-request",
      text: "بررسی درخواست ها",
    },
    {
      id: 2,
      img: "/Assets/Images/NavigatorIcons/CheckedRequestAdminIcon/Grey.svg",
      activeImg:
        "/Assets/Images/NavigatorIcons/CheckedRequestAdminIcon/Blue.svg",
      navigate: "/admin-dashboard/checked-request",
      text: "درخواست های بررسی شده",
    },
    {
      id: 3,
      img: "/Assets/Images/NavigatorIcons/AllEmployeeIcon/Grey.svg",
      activeImg: "/Assets/Images/NavigatorIcons/AllEmployeeIcon/Blue.svg",
      navigate: "/admin-dashboard/all-employees",
      text: "لیست کارمندان",
    },
    {
      id: 4,
      img: "/Assets/Images/NavigatorIcons/AllStudentsIcon/Grey.svg",
      activeImg: "/Assets/Images/NavigatorIcons/AllStudentsIcon/Blue.svg",
      navigate: "/admin-dashboard/all-students",
      text: "لیست دانشجویان",
    },
    {
      id: 5,
      img: "/Assets/Images/NavigatorIcons/DataIcon/Grey.svg",
      activeImg: "/Assets/Images/NavigatorIcons/DataIcon/Blue.svg",
      navigate: "/admin-dashboard/system-data",
      text: "داده های سامانه",
    },
  ]);

  return (
    <Container>
      <StudentRightSide data={navItems}></StudentRightSide>
      <StudentLeftSide></StudentLeftSide>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 97vh;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  background-color: ${Theme.colorBackgroundPage};
`;
